var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientClassificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1V1C38.2548 1 49 11.7452 49 25V25C49 38.2548 38.2548 49 25 49V49C11.7452 49 1 38.2548 1 25V25Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 16H17C15.9 16 15 16.9 15 18V32C15 33.1 15.9 34 17 34H33C34.1 34 35 33.1 35 32V18C35 16.9 34.1 16 33 16ZM22 30H19C18.45 30 18 29.55 18 29C18 28.45 18.45 28 19 28H22C22.55 28 23 28.45 23 29C23 29.55 22.55 30 22 30ZM22 26H19C18.45 26 18 25.55 18 25C18 24.45 18.45 24 19 24H22C22.55 24 23 24.45 23 25C23 25.55 22.55 26 22 26ZM22 22H19C18.45 22 18 21.55 18 21C18 20.45 18.45 20 19 20H22C22.55 20 23 20.45 23 21C23 21.55 22.55 22 22 22ZM31.7 24.12L28.53 27.29C28.14 27.68 27.5 27.68 27.11 27.29L25.7 25.87C25.31 25.48 25.31 24.85 25.7 24.46C26.09 24.07 26.72 24.07 27.11 24.46L27.82 25.17L30.29 22.7C30.68 22.31 31.31 22.31 31.7 22.7L31.71 22.71C32.09 23.1 32.09 23.74 31.7 24.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientClassificationIcon);
export default __webpack_public_path__ + "static/media/client_classification_icon.339ae8083e4dbb35d77131156c5aba98.svg";
export { ForwardRef as ReactComponent };